import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

// Translation mappings
const translations = {
  th: {
    // SelectCourtType
    'select_court_type': 'กรุณาเลือกสนาม',
    'hello': 'สวัสดี',
    'loading_data': 'กำลังโหลดข้อมูล...',
    'try_again': 'ลองใหม่',
    'failed_to_load_courts': 'Failed to load court types. Please try again.',
    'football': 'สนามฟุตบอล',
    'basketball': 'สนามบาสเก็ตบอล',
    'badminton': 'สนามแบดมินตัน',
    'pickleball': 'สนามพิคเกิลบอล',
    'studio': 'ห้องสตูดิโอ',
    'others': 'อื่นๆ',
    
    // CourtDetails
    'back': 'กลับ',
    'book': 'จองสนาม',
    'select_court': 'เลือกสนาม',
    'please_select_court_dropdown': 'กรุณาเลือกสนาม',
    'select_start_time': 'เลือกเวลาเริ่ม',
    'select_end_time': 'เลือกเวลาสิ้นสุด',
    'please_select_start_time': 'กรุณาเลือกเวลาเริ่ม',
    'please_select_end_time': 'กรุณาเลือกเวลาสิ้นสุด',
    'booking_status': 'สถานะการจอง',
    'court_map': 'ผังสนาม',
    'tap_to_enlarge': 'แตะเพื่อขยาย',
    'closed_this_date': 'ปิดทำการในวันนี้',
    'closed_no_booking': 'ไม่สามารถจองได้ในวันที่เลือก',
    'free_cancels_left': 'ยกเลิกฟรี',
    'this_month': 'เดือนนี้',
    'cancel_this_booking': 'ยกเลิกการจองนี้?',
    'you_will_get_back': 'คุณจะได้รับคืน',
    'cancel_quota_used': 'ยกเลิกครบโควตาแล้ว · ติดต่อแอดมิน',
    'pay_now': 'ชำระเงิน',
    'pay_before': 'ชำระภายใน',
    'opening_payment': 'กำลังเปิด…',
    'payment_expired': 'หมดเวลาชำระ',
    'payment_link_limit': 'ขอ QR ใหม่ครบจำนวนแล้ว กรุณาจองใหม่',
    'payment_link_error': 'เปิดหน้าชำระเงินไม่สำเร็จ กรุณาลองอีกครั้ง',
    'refund_title_slot_taken': 'ช่วงเวลานี้มีผู้จองไปแล้ว',
    'refund_title_booking_cancelled': 'การจองนี้ถูกยกเลิกไปแล้ว',
    'refund_title_slot_passed': 'เลยเวลาจองแล้ว',
    'refund_title_already_paid': 'ได้รับเงินซ้ำสำหรับการจองนี้',
    'refund_title_booking_missing': 'ไม่พบการจองของการชำระเงินนี้',
    'refund_body': 'เราได้รับเงินของคุณแล้ว แต่ไม่สามารถยืนยันการจองนี้ได้ กรุณาแคปหน้าจอนี้แล้วติดต่อเจ้าหน้าที่เพื่อขอคืนเงิน',
    'refund_body_already_paid': 'การจองของคุณยืนยันแล้ว แต่เราได้รับเงินซ้ำอีกครั้ง กรุณาแคปหน้าจอนี้แล้วติดต่อเจ้าหน้าที่เพื่อขอคืนเงินส่วนที่ชำระซ้ำ',
    'refund_amount': 'ยอดที่ต้องคืน',
    'refunded_amount': 'ยอดที่คืนแล้ว',
    'refund_body_refunded': 'เจ้าหน้าที่คืนเงินรายการนี้ให้คุณแล้ว หากยังไม่ได้รับ กรุณาติดต่อเจ้าหน้าที่พร้อมรหัสอ้างอิง',
    'refund_booking': 'การจอง',
    'refund_ref': 'รหัสอ้างอิง',
    'bank_ref': 'เลขอ้างอิงธนาคาร',
    'refund_status_due': 'รอคืนเงิน · กรุณาติดต่อเจ้าหน้าที่พร้อมรหัสอ้างอิง',
    'refund_status_refunded': 'คืนเงินแล้ว',
    'contact_admin_to_cancel': 'ติดต่อแอดมินเพื่อยกเลิก',
    'confirm_cancel_btn': 'ยืนยันยกเลิก',
    'keep_booking': 'ไม่',
    'cancel_failed': 'ยกเลิกไม่สำเร็จ',
    'booking_cancelled_ok': 'ยกเลิกการจองสำเร็จ',
    'buy_tokens': 'เติมชั่วโมง',
    'top_up': 'เติมชั่วโมง',
    'please_select': 'เลือก...',
    'select_type_to_see_packs': 'เลือกประเภทสนามเพื่อดูแพ็กเกจ',
    'no_packs_available': 'ไม่มีแพ็กเกจในขณะนี้',
    'pay_via_chillpay': 'ชำระผ่าน QR',
    'purchase_failed': 'เติมชั่วโมงไม่สำเร็จ',
    'need_more_tokens': 'ต้องการอีก',
    'buy_pack': 'ซื้อแพ็กเกจ',
    'tokens_added': 'เติมชั่วโมงสำเร็จ',
    'new_balance': 'ยอดคงเหลือ',
    'your_tokens': 'ชั่วโมงคงเหลือ',
    'promotion': 'โปรโมชั่น',
    'sign_in': 'เข้าสู่ระบบ',
    'please_sign_in': 'เซสชันหมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง',
    'too_many_attempts': 'พยายามหลายครั้งเกินไป กรุณารอสักครู่แล้วลองใหม่',
    'booking_min_note': 'ลูกค้าสามารถจองสนามได้ตั้งแต่ครึ่งชั่วโมงขึ้นไป',
    'credit_validity_note': 'เหรียญชั่วโมงมีอายุการใช้งาน 1 ปี',
    'loading_booking_data': 'กำลังโหลดข้อมูลการจอง...',
    'confirm_booking': 'ยืนยันการจอง',
    'court': 'สนาม:',
    'date': 'วันที่:',
    'time': 'เวลา:',
    'cost': 'ยอดชำระ:',
    'not_specified': 'ไม่ระบุ',
    'cancel': 'ยกเลิก',
    'confirm_and_pay': 'ยืนยันและชำระเงิน',
    'book_now': 'จองเลย',
    'booking_limit_30_days': 'สามารถจองล่วงหน้าได้สูงสุด 30 วัน',
    
    // Payment
    'payment_title': 'ชำระเงิน',
    'payment_subtitle': 'กรุณาสแกน QR Code เพื่อชำระเงิน',
    'booking_summary': 'สรุปการจอง',
    'scan_qr_code': 'สแกน QR Code',
    'qr_loading': 'กำลังสร้าง QR Code...',
    'qr_instructions': 'เปิดแอปธนาคารและสแกน QR Code เพื่อชำระเงิน',
    'payment_pending': 'รอการชำระเงิน',
    'payment_completed': 'ชำระเงินสำเร็จ',
    'payment_failed': 'ชำระเงินล้มเหลว',
    'confirm_payment': 'ยืนยันการชำระเงิน',
    'cancel_payment': 'ยกเลิกการชำระเงิน',
    'payment_error': 'เกิดข้อผิดพลาดในการชำระเงิน',
    'checking_payment': 'กำลังตรวจสอบการชำระเงิน',
    'attempts': 'ครั้ง',
    'minutes': 'นาที',
    
    // Rules Modal
    'rules_and_terms': 'กฎและเงื่อนไข',
    'court_rules': 'กฎของสนาม',
    'loading_rules': 'กำลังโหลดกฎ...',
    'no_rules_available': 'ไม่มีกฎที่กำหนด',
    'i_have_read_and_understand': 'ฉันได้อ่านและเข้าใจ',
    'and_agree_to_comply': 'และยินยอมปฏิบัติตาม',
    'proceed_to_payment': 'ดำเนินการชำระเงิน',
    'payment_method': 'วิธีการชำระเงิน',
    'processing': 'กำลังประมวลผล...',
    'secure_payment_notice': 'การชำระเงินของคุณจะถูกประมวลผลอย่างปลอดภัย',
    'redirecting': 'กำลังเปลี่ยนเส้นทาง...',
    'verifying_payment': 'กำลังตรวจสอบการชำระเงิน...',
    'payment_successful': 'การชำระเงินสำเร็จ',
    'redirecting_to_receipt': 'กำลังเปลี่ยนเส้นทางไปยังใบเสร็จ...',
    'returned_from_payment': 'คุณได้กลับมาจากการชำระเงินแล้ว กำลังตรวจสอบสถานะ...',
    'payment_cancelled': 'การชำระเงินถูกยกเลิกโดยผู้ใช้',
    'payment_timeout': 'การชำระเงินหมดเวลา',
    'payment_rejected': 'การชำระเงินถูกปฏิเสธโดยธนาคาร',
    'please_wait': 'กรุณารอสักครู่...',
    'please_try_again': 'กรุณาลองใหม่อีกครั้ง',
    'this_may_take_a_few_seconds': 'อาจใช้เวลาสักครู่',
    'payment_was_not_completed': 'การชำระเงินไม่สำเร็จ',
    'amount': 'จำนวนเงิน',
    'payment_failed_help': 'หากคุณมีปัญหาในการชำระเงิน กรุณาติดต่อผู้ดูแลระบบ',
    
    // AnalogClock
    'available': 'ว่าง',
    'booked': 'จองแล้ว',
    'closed': 'ปิด',
    'opening_hours': 'เวลาเปิด',
    
    // Receipt
    'booking_confirmed': 'การจองสำเร็จ!',
    'thank_you_booking': 'ขอบคุณสำหรับการจอง',
    'booked_by': 'จองโดย:',
    'line_user': 'ผู้ใช้ LINE',
    'booking_details': 'รายละเอียดการจอง:',
    'court_type': 'ประเภทสนาม:',
    'duration': 'ระยะเวลา:',
    'total_amount': 'จำนวนเงินรวม:',
    'booking_reference': 'รหัสการจอง',
    'download_receipt': 'ดาวน์โหลดใบเสร็จ',
    'save_receipt': 'บันทึกใบเสร็จ',
    'save_to_gallery': 'บันทึกลงแกลเลอรี่',
    'share_receipt': 'แชร์ใบเสร็จ',
    'receipt_saved': 'บันทึกใบเสร็จสำเร็จ',
    'receipt_shared': 'แชร์ใบเสร็จสำเร็จ',
    'receipt_share_text': 'ใบเสร็จการจองสนาม',
    'save_receipt_error': 'เกิดข้อผิดพลาดในการบันทึกใบเสร็จ',
    'saving': 'กำลังบันทึก...',
    'back_to_home': 'กลับหน้าหลัก',
    'thank_you': 'ขอบคุณ',
    'see_you_on': 'พบกันวันที่',
    'hour': 'ชั่วโมง',
    'hours': 'ชั่วโมง',
    'show_this_page': 'กรุณาแสดงหน้านี้ก่อนเข้าสนาม',
    'contact_admin': 'หากมีคำถาม ติดต่อเจ้าหน้าที่ได้ในเวลาทำการ',
    'weekday_hours': 'จันทร์-ศุกร์ 14:00 - 23:00',
    'weekend_hours': 'เสาร์-อาทิตย์ 09:00 - 23:00',
    'receipt_error': 'เกิดข้อผิดพลาดในการโหลดใบเสร็จ',
    'cancel_booking': 'ยกเลิกการจอง',
    'cancel_booking_confirm': 'คุณต้องการยกเลิกการจองนี้หรือไม่?',
    'cancel_booking_success': 'ยกเลิกการจองสำเร็จ',
    'cancel_booking_error': 'เกิดข้อผิดพลาดในการยกเลิกการจอง',
    'only_pending_can_cancel': 'สามารถยกเลิกได้เฉพาะการจองที่รอดำเนินการเท่านั้น',
    'booking_not_found': 'ไม่พบการจอง',
    'cannot_cancel_own_booking': 'คุณสามารถยกเลิกการจองของคุณเองเท่านั้น',
    'cannot_cancel_expired': 'ไม่สามารถยกเลิกการจองที่หมดอายุได้',
    
    // UserHeader
    'line_app_required': '⚠️ ต้องเปิดใน LINE App',
    'line_user_label': 'ผู้ใช้ LINE',
    'user_profile': 'ข้อมูลผู้ใช้',
    'name': 'ชื่อ',
    'user_id': 'ไอดี',
    'points': 'คะแนน',
    
    // Booking History
    'booking_history': 'ประวัติการจอง',
    'history_cancel': 'ประวัติ · ยกเลิกการจอง',
    'history': 'ประวัติ',
    'no_bookings_yet': 'ยังไม่มีประวัติการจอง',
    'book_your_first_court': 'จองสนามครั้งแรกเพื่อดูประวัติที่นี่',
    'confirmed': 'ยืนยันแล้ว',
    'cancelled': 'ยกเลิกแล้ว',
    'payment': 'การชำระเงิน',
    'used': 'ใช้',
    'tokens': 'ชั่วโมง',
    'no_tokens_available': 'ไม่มีชั่วโมง',
    'load_more': 'โหลดเพิ่มเติม',
    'all_bookings_shown': 'แสดงการจองทั้งหมดแล้ว',
    'load_failed_retry': 'โหลดไม่สำเร็จ — แตะเพื่อลองใหม่',
    'paid': 'ชำระแล้ว',
    'pending': 'รอดำเนินการ',
    'failed': 'ล้มเหลว',
    'status': 'สถานะ',
    'click_to_view_receipt': 'คลิกเพื่อดูใบเสร็จ',
    'click_to_complete_payment': 'คลิกเพื่อชำระเงิน',
    'to': 'ถึง',

    // Payment methods (CourtDetails / Receipt)
    'select_payment_method': 'เลือกวิธีชำระเงิน',
    'qr_code_payment': 'ชำระผ่าน QR Code',
    'tokens_payment': 'ชำระด้วยชั่วโมง',
    'use_tokens': 'ใช้ชั่วโมง',
    'remaining_tokens': 'คงเหลือ',
    'insufficient_tokens': 'ชั่วโมงไม่เพียงพอ',
    'tokens_used': 'ชั่วโมงที่ใช้',
    // Language sentinel: t('language') returns the active language code.
    'language': 'th',
    
    // Contact Information
    'contact_information': 'ข้อมูลติดต่อ',
    'nickname': 'ชื่อเล่น',
    'mobile_phone': 'เบอร์โทรศัพท์',
    'enter_nickname': 'กรุณาใส่ชื่อเล่น',
    'enter_mobile_phone': 'กรุณาใส่เบอร์โทรศัพท์',
    'nickname_required': 'กรุณาใส่ชื่อเล่น',
    'mobile_phone_required': 'กรุณาใส่เบอร์โทรศัพท์',
    'invalid_phone_number': 'เบอร์โทรศัพท์ไม่ถูกต้อง',
    'saving_contact_info': 'กำลังบันทึกข้อมูลติดต่อ...',
    'contact_info_saved': 'บันทึกข้อมูลติดต่อสำเร็จ',
    'contact_info_error': 'เกิดข้อผิดพลาดในการบันทึกข้อมูลติดต่อ',
    'contact_details': 'ข้อมูลติดต่อ',
    'receipt_contact_info': 'ข้อมูลติดต่อสำหรับการจอง',
    
    // Admin Booking
    'admin_booking': 'จองแทนลูกค้า',
    'create_admin_booking': 'สร้างการจองแทนลูกค้า',
    'select_customer': 'เลือกลูกค้า',
    'customer_name': 'ชื่อลูกค้า',
    'customer_phone': 'เบอร์โทรศัพท์ลูกค้า',
    'special_notes': 'หมายเหตุพิเศษ',
    'admin_booked': 'จองโดยแอดมิน',
    'vip_customer': 'ลูกค้า VIP',
    'booking_created_successfully': 'สร้างการจองสำเร็จ',
    'booking_creation_failed': 'สร้างการจองล้มเหลว',
    'enter_customer_name': 'กรุณาใส่ชื่อลูกค้า',
    'enter_customer_phone': 'กรุณาใส่เบอร์โทรศัพท์ลูกค้า',
    'customer_name_required': 'กรุณาใส่ชื่อลูกค้า',
    'customer_phone_required': 'กรุณาใส่เบอร์โทรศัพท์ลูกค้า',
    
    // Common
    'loading': 'กำลังโหลด...',
    'error': 'เกิดข้อผิดพลาด',
    'user_info_not_available': 'ข้อมูลผู้ใช้ไม่พร้อมใช้งาน',
    'failed_to_initialize': 'ล้มเหลวในการเริ่มต้น:',
    'close': 'ปิด',
    'note': 'หมายเหตุ',
    'morning': 'เช้า',
    'afternoon': 'บ่าย',
  },
  en: {
    // SelectCourtType
    'select_court_type': 'Please Select Court',
    'hello': 'Hello',
    'loading_data': 'Loading data...',
    'try_again': 'Try Again',
    'failed_to_load_courts': 'Failed to load court types. Please try again.',
    'football': 'Football Field',
    'basketball': 'Basketball Court',
    'badminton': 'Badminton Court',
    'pickleball': 'Pickleball Court',
    'studio': 'Studio Room',
    'others': 'Others',
    
    // CourtDetails
    'back': 'Back',
    'book': 'Book Court',
    'select_court': 'Select Court',
    'please_select_court_dropdown': 'Please select a court',
    'select_start_time': 'Select Start Time',
    'select_end_time': 'Select End Time',
    'please_select_start_time': 'Please select start time',
    'please_select_end_time': 'Please select end time',
    'booking_status': 'Booking Status',
    'court_map': 'Court Map',
    'tap_to_enlarge': 'Tap to enlarge',
    'closed_this_date': 'Closed on this date',
    'closed_no_booking': 'Booking is not available on the selected date',
    'free_cancels_left': 'Free cancels',
    'this_month': 'this month',
    'cancel_this_booking': 'Cancel this booking?',
    'you_will_get_back': 'You will get back',
    'cancel_quota_used': 'Free cancels used up · contact admin',
    'pay_now': 'Pay now',
    'pay_before': 'Pay by',
    'opening_payment': 'Opening…',
    'payment_expired': 'Payment expired',
    'payment_link_limit': 'QR limit reached, please book again',
    'payment_link_error': "Couldn't open payment, please try again",
    'refund_title_slot_taken': 'This slot was taken before your payment came through',
    'refund_title_booking_cancelled': 'This booking had already been cancelled',
    'refund_title_slot_passed': 'This booking time had already passed',
    'refund_title_already_paid': 'We received a second payment for this booking',
    'refund_title_booking_missing': "We couldn't match this payment to a booking",
    'refund_body': "We received your payment but couldn't confirm this booking. Please screenshot this page and contact staff for a refund.",
    'refund_body_already_paid': 'Your booking is confirmed, but we received an extra payment for it. Please screenshot this page and contact staff to refund the extra payment.',
    'refund_amount': 'Amount to refund',
    'refunded_amount': 'Amount refunded',
    'refund_body_refunded': "Staff have refunded this payment. If you haven't received it, contact staff with the reference.",
    'refund_booking': 'Booking',
    'refund_ref': 'Reference',
    'bank_ref': 'Bank reference',
    'refund_status_due': 'Refund pending · contact staff with the reference',
    'refund_status_refunded': 'Refunded',
    'contact_admin_to_cancel': 'Contact admin to cancel',
    'confirm_cancel_btn': 'Confirm cancel',
    'keep_booking': 'No',
    'cancel_failed': 'Failed to cancel',
    'booking_cancelled_ok': 'Booking cancelled',
    'buy_tokens': 'Top up',
    'top_up': 'Top up',
    'please_select': 'Select...',
    'select_type_to_see_packs': 'Select a court type to see packs',
    'no_packs_available': 'No packs available',
    'pay_via_chillpay': 'Pay via QR',
    'purchase_failed': 'Top-up failed',
    'need_more_tokens': 'Need',
    'buy_pack': 'Buy a pack',
    'tokens_added': 'Hours added',
    'new_balance': 'New balance',
    'your_tokens': 'Hours remaining',
    'promotion': 'Promotion',
    'sign_in': 'Sign in',
    'please_sign_in': 'Your session ended — please sign in again',
    'too_many_attempts': 'Too many attempts — please wait a moment and try again',
    'booking_min_note': 'Courts are bookable from 30 minutes upward',
    'credit_validity_note': 'Hour credits are valid for 1 year',
    'loading_booking_data': 'Loading booking data...',
    'confirm_booking': 'Confirm Booking',
    'court': 'Court:',
    'date': 'Date:',
    'time': 'Time:',
    'cost': 'Cost:',
    'not_specified': 'Not specified',
    'cancel': 'Cancel',
    'confirm_and_pay': 'Confirm & Pay',
    'book_now': 'Book Now',
    'booking_limit_30_days': 'You can book up to 30 days in advance',
    
    // Payment
    'payment_title': 'Payment',
    'payment_subtitle': 'Please scan the QR code to pay',
    'booking_summary': 'Booking Summary',
    'scan_qr_code': 'Scan QR Code',
    'qr_loading': 'Generating QR Code...',
    'qr_instructions': 'Open your bank app and scan the QR code to pay',
    'payment_pending': 'Payment Pending',
    'payment_completed': 'Payment Completed',
    'payment_failed': 'Payment Failed',
    'confirm_payment': 'Confirm Payment',
    'cancel_payment': 'Cancel Payment',
    'payment_error': 'Payment error',
    'checking_payment': 'Checking payment',
    'attempts': 'attempts',
    'minutes': 'Minutes',
    
    // Rules Modal
    'rules_and_terms': 'Rules and Terms',
    'court_rules': 'Court Rules',
    'loading_rules': 'Loading rules...',
    'no_rules_available': 'No rules available',
    'i_have_read_and_understand': 'I have read and understand the',
    'and_agree_to_comply': 'and agree to comply',
    'proceed_to_payment': 'Proceed to Payment',
    'payment_method': 'Payment Method',
    'processing': 'Processing...',
    'secure_payment_notice': 'Your payment will be processed securely',
    'redirecting': 'Redirecting...',
    'verifying_payment': 'Verifying payment...',
    'payment_successful': 'Payment successful',
    'redirecting_to_receipt': 'Redirecting to receipt...',
    'returned_from_payment': 'You have returned from payment. Checking status...',
    'payment_cancelled': 'Payment cancelled by user',
    'payment_timeout': 'Payment timeout',
    'payment_rejected': 'Payment rejected by bank',
    'please_wait': 'Please wait...',
    'please_try_again': 'Please try again',
    'this_may_take_a_few_seconds': 'This may take a few seconds',
    'payment_was_not_completed': 'Payment was not completed',
    'amount': 'Amount',
    'payment_failed_help': 'If you have issues with payment, please contact the system administrator',
    
    // AnalogClock
    'available': 'Available',
    'booked': 'Booked',
    'closed': 'Closed',
    'opening_hours': 'Opening Hours',
    
    // Receipt
    'booking_confirmed': 'Booking Confirmed!',
    'thank_you_booking': 'Thank you for your booking',
    'booked_by': 'Booked by:',
    'line_user': 'LINE User',
    'booking_details': 'Booking Details:',
    'court_type': 'Court Type:',
    'duration': 'Duration:',
    'total_amount': 'Total Amount:',
    'booking_reference': 'Booking Reference',
    'download_receipt': 'Download Receipt',
    'save_receipt': 'Save Receipt',
    'save_to_gallery': 'Save to Gallery',
    'share_receipt': 'Share Receipt',
    'receipt_saved': 'Receipt saved successfully',
    'receipt_shared': 'Receipt shared successfully',
    'receipt_share_text': 'Court booking receipt',
    'save_receipt_error': 'Error saving receipt',
    'saving': 'Saving...',
    'back_to_home': 'Back to Home',
    'thank_you': 'Thank you',
    'see_you_on': 'See you on',
    'hour': 'hour',
    'hours': 'hours',
    'show_this_page': 'Please show this page before entering the court',
    'contact_admin': 'If you have any questions, contact admin during office hours',
    'weekday_hours': 'Mon-Fri 14:00 - 23:00',
    'weekend_hours': 'Sat-Sun 09:00 - 23:00',
    'receipt_error': 'Error loading receipt',
    'cancel_booking': 'Cancel Booking',
    'cancel_booking_confirm': 'Are you sure you want to cancel this booking?',
    'cancel_booking_success': 'Booking cancelled successfully',
    'cancel_booking_error': 'Error cancelling booking',
    'only_pending_can_cancel': 'Only pending bookings can be cancelled',
    'booking_not_found': 'Booking not found',
    'cannot_cancel_own_booking': 'You can only cancel your own bookings',
    'cannot_cancel_expired': 'Cannot cancel expired booking',
    
    // UserHeader
    'line_app_required': '⚠️ LINE App Required',
    'line_user_label': 'LINE User',
    'user_profile': 'User Profile',
    'name': 'Name',
    'user_id': 'User ID',
    'points': 'Points',
    
    // Booking History
    'booking_history': 'Booking History',
    'history_cancel': 'History · Cancel',
    'history': 'History',
    'no_bookings_yet': 'No bookings yet',
    'book_your_first_court': 'Book your first court to see history here',
    'confirmed': 'Confirmed',
    'cancelled': 'Cancelled',
    'payment': 'Payment',
    'used': 'Used',
    'tokens': 'hours',
    'no_tokens_available': 'No hours available',
    'load_more': 'Load more',
    'all_bookings_shown': 'All bookings shown',
    'load_failed_retry': 'Failed to load — tap to retry',
    'paid': 'Paid',
    'pending': 'Pending',
    'failed': 'Failed',
    'status': 'Status',
    'click_to_view_receipt': 'Click to view receipt',
    'click_to_complete_payment': 'Click to complete payment',
    'to': 'to',

    // Payment methods (CourtDetails / Receipt)
    'select_payment_method': 'Select Payment Method',
    'qr_code_payment': 'QR Code Payment',
    'tokens_payment': 'Hours Payment',
    'use_tokens': 'Use hours',
    'remaining_tokens': 'remaining',
    'insufficient_tokens': 'Insufficient hours',
    'tokens_used': 'Hours used',
    // Language sentinel: t('language') returns the active language code.
    'language': 'en',
    
    // Contact Information
    'contact_information': 'Contact Information',
    'nickname': 'Nickname',
    'mobile_phone': 'Mobile Phone',
    'enter_nickname': 'Enter nickname',
    'enter_mobile_phone': 'Enter mobile phone',
    'nickname_required': 'Nickname is required',
    'mobile_phone_required': 'Mobile phone is required',
    'invalid_phone_number': 'Invalid phone number',
    'saving_contact_info': 'Saving contact information...',
    'contact_info_saved': 'Contact information saved successfully',
    'contact_info_error': 'Error saving contact information',
    'contact_details': 'Contact Details',
    'receipt_contact_info': 'Contact Information for Booking',
    
    // Admin Booking
    'admin_booking': 'Admin Booking',
    'create_admin_booking': 'Create Admin Booking',
    'select_customer': 'Select Customer',
    'customer_name': 'Customer Name',
    'customer_phone': 'Customer Phone',
    'special_notes': 'Special Notes',
    'admin_booked': 'Admin Booked',
    'vip_customer': 'VIP Customer',
    'booking_created_successfully': 'Booking created successfully',
    'booking_creation_failed': 'Booking creation failed',
    'enter_customer_name': 'Enter customer name',
    'enter_customer_phone': 'Enter customer phone',
    'customer_name_required': 'Customer name is required',
    'customer_phone_required': 'Customer phone is required',
    
    // Common
    'loading': 'Loading...',
    'error': 'Error',
    'user_info_not_available': 'User information not available',
    'failed_to_initialize': 'Failed to initialize:',
    'close': 'Close',
    'note': 'Note',
    'morning': 'AM',
    'afternoon': 'PM',
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('th');

  const t = (key) => {
    return translations[language]?.[key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'th' ? 'en' : 'th');
  };

  const value = {
    language,
    setLanguage,
    toggleLanguage,
    t
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}; 